import { BaseAPI } from 'api/BaseAPI';

export class OnboardingAPI extends BaseAPI {}
